/* Franklin & Co.: required Dahlia Tuber Terms tick box in the cart. */
import Cart from "cart-store";

const TUBER_TYPE = "Dahlia Tuber";

class TuberTerms extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="checkbox"]');
    this.error = this.querySelector("cart-terms-error");
    this.form = this.closest("form") || document.getElementById(this.input.getAttribute("form"));
    this.onSubmit = (e) => {
      if (!this.hidden && !this.input.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.showError(true);
      }
    };
    this.onChange = () => {
      if (this.input.checked) this.showError(false);
    };
    if (this.form) this.form.addEventListener("submit", this.onSubmit);
    this.input.addEventListener("change", this.onChange);
    this.update(Cart.getState().cart);
    this.unsubscribe = Cart.subscribe((state) => this.update(state.cart));
  }
  disconnectedCallback() {
    if (this.form) this.form.removeEventListener("submit", this.onSubmit);
    if (this.input) this.input.removeEventListener("change", this.onChange);
    if (this.unsubscribe) this.unsubscribe();
  }
  update(cart) {
    const hasTuber = !!(cart && cart.items && cart.items.some((item) => item.product_type === TUBER_TYPE));
    this.hidden = !hasTuber;
    if (!hasTuber) {
      this.input.checked = false;
      this.showError(false);
    }
  }
  showError(visible) {
    if (!this.error) return;
    if (visible) {
      this.error.removeAttribute("hidden");
      this.error.classList.add("is-active");
    } else {
      this.error.classList.remove("is-active");
      this.error.setAttribute("hidden", "");
    }
  }
}

if (!customElements.get("tuber-terms")) customElements.define("tuber-terms", TuberTerms);